export default __webpack_public_path__ + "static/media/close.70bb7e42.svg";